import { useDispatch } from "react-redux";
import { AppDispatch } from "configureStore";
import { useTranslation } from "react-i18next";
import {
  setModalxComponent,
  setModalxComponentProps,
} from "components/modalx/modalx.slice";
import { PRIMARY_BUTTON } from "containers/settings/ui/buttonStyles";

interface NewDocumentButtonProps {
  userId: string;
  /** The document is signed by the manager, so it cannot be filled in without one. */
  managerId: string | undefined;
  labelKey: string;
}

/** Opens the form that fills in a document (leave request, ...) for the person. */
export default function NewDocumentButton({
  userId,
  managerId,
  labelKey,
}: NewDocumentButtonProps) {
  const dispatch: AppDispatch = useDispatch();
  const { t } = useTranslation();

  if (!managerId) {
    return (
      <div className="flex flex-col gap-1 sm:items-end">
        <button type="button" className={PRIMARY_BUTTON} disabled>
          {t(labelKey)}
        </button>
        <p className="text-sm text-red-600">
          {t("manager_should_be_assigned_first")}
        </p>
      </div>
    );
  }

  const openForm = () => {
    dispatch(setModalxComponent("UserDocumentForm"));
    dispatch(
      setModalxComponentProps({
        user: userId,
        subject: "user",
        signType: "Click",
        managerSigner: managerId,
      })
    );
  };

  return (
    <button type="button" className={PRIMARY_BUTTON} onClick={openForm}>
      {t(labelKey)}
    </button>
  );
}
